import { render, staticRenderFns } from "./BorderEditor.vue?vue&type=template&id=598da5de&scoped=true&"
import script from "./BorderEditor.vue?vue&type=script&lang=js&"
export * from "./BorderEditor.vue?vue&type=script&lang=js&"
import style0 from "./BorderEditor.vue?vue&type=style&index=0&id=598da5de&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598da5de",
  null
  
)

export default component.exports